import $ from 'jquery';

$(() => {
    $('.toggle-menu').click((e) => {
        e.preventDefault();
        $('.side-nav').removeClass('side-nav-hidden');
        window.scrollTo(0, 0);
    });

    $('.side-nav__cancel').click((e) => {
        console.log('cancel');
        e.preventDefault();
        $('.side-nav').addClass('side-nav-hidden');
    });

    $('.side-nav__menu .nav-link').click((e) => {
        let link = $(e.target);
        if (!link.hasClass('accordion__header')) {
            let accordions = $('.side-nav .accordion');
            accordions.addClass('accordion-collapsed');
            accordions.find('.accordion__disclose-symbol').each(function(index) {
                this.setDirection('right');
            });
            $('.side-nav').addClass('side-nav-hidden');
        }
    });
})
